<template>
    <div class="eval-page">
        <!-- 悬浮返回按钮 -->
        <div class="float-back-btn" @click="goBack">
            <span class="back-icon">←</span>
            <span class="back-label">返回列表</span>
        </div>

        <!-- iframe容器 -->
        <div ref="iframeWrap" class="iframe-container"></div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            iframeUrl: '', // 测评页面完整URL
        };
    },
    created() {
        // 拼接测评地址（对应 uniapp 的 onLoad(options)，evalID 从路由 query 获取）
        const baseUrl = 'https://file.guanaijiajia.com/evaluationH5New/index_table.html';
        const fixedParams = 'userId=25996532&systemflag=3888&type=1&evalFlag=0';
        const evalID = this.$route.query.evalID || 67;
        this.iframeUrl = `${baseUrl}?${fixedParams}&evalID=${evalID}&random=${
            Math.random() * 1000
        }`;
    },
    mounted() {
        this.$nextTick(() => {
            this.createIframe();
        });
    },
    methods: {
        /**
         * 创建iframe加载测评页面
         */
        createIframe() {
            if (!this.iframeUrl) return;
            const wrap = this.$refs.iframeWrap;
            if (!wrap) return;
            const iframe = document.createElement('iframe');
            iframe.src = this.iframeUrl;
            iframe.style.width = '100%';
            iframe.style.height = '100%';
            iframe.style.border = 'none';
            wrap.appendChild(iframe);
        },

        /**
         * 返回门户列表页
         */
        goBack() {
            this.$router.replace('/portal');
        },
    },
};
</script>

<style lang="scss" scoped>
.eval-page {
    width: 100vw;
    height: 100vh;
    position: relative;
    overflow: hidden;
}

/* ==================== 悬浮返回按钮 ==================== */
.float-back-btn {
    position: fixed;
    top: 30rpx;
    left: 24rpx;
    z-index: 99999;
    display: flex;
    align-items: center;
    background: rgba(255, 255, 255, 0.95);
    border-radius: 40rpx;
    padding: 14rpx 28rpx;
    cursor: pointer;
    box-shadow: 0 4rpx 20rpx rgba(0, 0, 0, 0.15), 0 2rpx 8rpx rgba(0, 0, 0, 0.08);
    transition: transform 0.2s ease, box-shadow 0.2s ease;

    &:active {
        transform: scale(0.95);
        box-shadow: 0 2rpx 10rpx rgba(0, 0, 0, 0.1);
    }
}

.back-icon {
    font-size: 32rpx;
    color: #e8735a;
    font-weight: 600;
    margin-right: 8rpx;
}

.back-label {
    font-size: 26rpx;
    color: #3d2c2c;
    font-weight: 500;
}

/* ==================== iframe容器 ==================== */
.iframe-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
</style>
